module.exports = __webpack_public_path__ + "img/SilksClub.53fdb2cf.jpg";